import React, {useState, useEffect } from "react";

import { fetchDataViewStandBy } from './_redux/TrainingMaterialsCrud';

import StandardNew from '../../components/standartComponents/standardNew'

/** Default system functions  */
import { getUserFactoryId, getUser } from '../../../index';
import api from '../../services/api';
import _ from 'lodash';

export default function TrainingMaterialNew(props) {
    const newstd = {
        name: '',
        materialDescription: '',
        targetPublic: 'Operador',
        category: 'Desenvolvimento',
        stepTpm: null,
        compliance: 'N/A',
        pillarResponsibilityId: null,
        StructureId: null,
        standardType: "TrainingMaterial",
        userId: getUser().id,
        status: 1,
        version: 1,
        steps: [],
        trainingUsers: [],
        epis: [],
        tools: [],
        lpps: [],
        images: []
    }

    var defaultDadosBasicos = [
        {
            name: 'materialDescription',
            desc: 'Descrição',
            class: 'col-12',
        },
        {
            name: 'targetPublic',
            desc: 'Público alvo',
            class: 'col-4',
            options: ['Geral', 'Administrativo', 'Auxiliar', 'Gestão', 'Manutenção', 'Operador']
        },
        {
            name: 'category',
            desc: 'Categoria',
            class: 'col-4',
            options: ['Compliance', 'Desenvolvimento', 'Funcional', 'NCE', 'Técnico', 'Treinamento']
        },
        {
            name: 'pillarResponsibilityId',
            desc: 'Pilar responsável',
            class: 'col-4',
            options: [],
            reference: 'category.NCE'
        },
        {
            name: 'stepTpm',
            desc: 'Passo TPM',
            class: 'col-4',
            options: [1,2,3,4,5,6,7],
            reference: 'category.Treinamento'
        }
    ]

    useEffect(() => {

        async function getPilarData() {
            const newDadosBasicos = [...defaultDadosBasicos];

            api.get('/structure/odata?$orderby=name asc&$select=name,id&$filter=typeId+eq+7%20and%20factoryId+eq+' + getUserFactoryId())
                .then(response => {
                    const options = response.data.value.map(({
                        id: key,
                        name: value,
                        ...rest
                    }) => ({
                        key, value, ...rest
                    }))
                    const idx = defaultDadosBasicos.findIndex(i => i.name === 'pillarResponsibilityId');
                    newDadosBasicos[idx].options = options;                 
                })
                .catch(error => {
                    console.log("Erro na localização da estruturas da fábrica, tente novamente!");
                });
            defaultDadosBasicos = newDadosBasicos;
        }

        getPilarData();
    }, [])


    return StandardNew(defaultDadosBasicos, props, newstd, fetchDataViewStandBy, 'TrainingMaterial');
}